import React from 'react';

import { Link } from 'react-router-dom';
import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import EditorialSpecList from './EditorialSpecList.component';
import { EditorialOffer } from '../../types/editorial-offer.type';

interface OfferCardProps {
  offer: EditorialOffer;
}

const useStyles = makeStyles((theme) => ({
  // `height: 100%` et le bouton poussé en bas par `marginTop: auto` alignent les deux appels à
  // l'action, malgré des critères de longueurs inégales d'une offre à l'autre.
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '2rem 1.75rem',
    borderRadius: 12,
    backgroundColor: '#fff',
    border: '1px solid rgba(102, 118, 29, 0.16)',
  },
  illustration: {
    width: 88,
    height: 88,
    objectFit: 'contain',
  },
  title: {
    fontFamily: 'Bitter, serif',
    fontWeight: 700,
    fontSize: '1.25rem',
    lineHeight: 1.25,
    color: theme.palette.client.primary.extraDark,
  },
  subtitle: {
    fontSize: '1rem',
    lineHeight: 1.5,
    color: '#4a4a4a',
  },
  // Une précision qui ne se range dans aucun critère : détachée sur le fond teinté de l'accent
  // clair, elle se distingue du sous-titre sans peser autant qu'un critère.
  note: {
    padding: '0.75rem 1rem',
    borderRadius: 8,
    backgroundColor: theme.palette.client.accent.light,
    fontSize: '0.92rem',
    lineHeight: 1.5,
    color: '#4a3520',
  },
  cta: {
    marginTop: 'auto',
    alignSelf: 'flex-start',
    color: theme.palette.client.accent.main,
    fontWeight: 600,
  },
}));

const OfferCard: React.FC<OfferCardProps> = ({ offer }) => {
  const classes = useStyles();

  const renderCta = () => {
    // Sans destination, le bouton reste un bouton : il ne doit produire aucun lien mort.
    if (!offer.ctaPath) {
      return (
        <Button className={classes.cta} disableRipple>
          {offer.ctaLabel}
        </Button>
      );
    }

    return (
      <Button className={classes.cta} component={Link} to={offer.ctaPath}>
        {offer.ctaLabel}
      </Button>
    );
  };

  return (
    <article className={classes.card}>
      <img className={classes.illustration} src={offer.illustration} alt={offer.illustrationAlt} />

      <Typography component="h3" className={classes.title}>
        {offer.title}
      </Typography>

      <Typography className={classes.subtitle}>{offer.subtitle}</Typography>

      {offer.note && <Typography className={classes.note}>{offer.note}</Typography>}

      {offer.specs && offer.specs.length > 0 && <EditorialSpecList specs={offer.specs} />}

      {renderCta()}
    </article>
  );
};

export default OfferCard;
